var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPngIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9453_135595)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6304 10.0415L25.84 10.0415L21.2122 5.07434L21.2122 9.62335C21.2122 9.8543 21.3995 10.0415 21.6304 10.0415ZM21.6304 11.4354L26.4811 11.4354L26.4811 27.9557L9.89389 27.9557L9.89389 24.9996L8.5 24.9996L8.5 28.2345C8.5 28.8504 8.99926 29.3496 9.61511 29.3496L26.7599 29.3496C27.3757 29.3496 27.875 28.8504 27.875 28.2345L27.875 10.6199C27.875 10.4145 27.8183 10.2147 27.7133 10.0415C27.6741 9.97683 27.6281 9.91587 27.5758 9.85973L21.5151 3.35459C21.4271 3.26019 21.3245 3.18279 21.2122 3.12464C21.0553 3.04332 20.8796 2.99961 20.6992 2.99961L9.61511 2.99961C8.99926 2.99961 8.5 3.49886 8.5 4.11472L8.5 12.9996L9.89389 12.9996L9.89389 4.3935L19.8183 4.3935L19.8183 9.62335C19.8183 10.6241 20.6296 11.4354 21.6304 11.4354Z",
    fill: "#1A1B1D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 13C1.84315 13 0.5 14.3431 0.5 16L0.5 22C0.5 23.6569 1.84315 25 3.5 25L21 25C22.6569 25 24 23.6569 24 22L24 16C24 14.3431 22.6569 13 21 13L3.5 13ZM20.3833 22.2L21.2563 22.2L21.2563 18.969L18.1333 18.969L18.1333 19.914L20.2393 19.914C20.1853 20.463 19.6993 21.345 18.4123 21.345C17.3143 21.345 16.3063 20.562 16.3063 19.005C16.3063 17.421 17.3863 16.683 18.4213 16.683C19.4383 16.683 20.0683 17.295 20.2843 18.015L21.3013 17.628C20.9593 16.575 19.9693 15.684 18.4213 15.684C16.7653 15.684 15.2083 16.908 15.2083 19.005C15.2083 21.111 16.6843 22.335 18.3493 22.335C19.3663 22.335 20.0233 21.858 20.3023 21.39L20.3833 22.2ZM14.0684 22.2L12.9434 22.2L9.79344 17.367L9.79344 22.2L8.71344 22.2L8.71344 15.819L10.0904 15.819L12.9884 20.346L12.9884 15.819L14.0684 15.819L14.0684 22.2ZM5.52196 18.753L4.39696 18.753L4.39696 16.773L5.52196 16.773C6.20596 16.773 6.61996 17.16 6.61996 17.772C6.61996 18.375 6.20596 18.753 5.52196 18.753ZM4.39696 19.707L5.68396 19.707C6.90796 19.707 7.71796 18.888 7.71796 17.763C7.71796 16.647 6.90796 15.819 5.68396 15.819L3.31696 15.819L3.31696 22.2L4.39696 22.2L4.39696 19.707Z",
    fill: "#1A1B1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9453_135595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "matrix(4.37114e-08 -1 -1 -4.37114e-08 32 32)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPngIcon);
export default __webpack_public_path__ + "static/media/png-icon.4f29eed70ec14eafdf5b0bdfa269b12a.svg";
export { ForwardRef as ReactComponent };